import React from 'react';
import './Alert.css';

export function Alert({ children, className = '' }) {
    return (
        <div className={`alert ${className}`} role="alert">
            {children}
        </div>
    );
}

export function AlertTitle({ children, className = '' }) {
    return <h5 className={`alert-title ${className}`}>{children}</h5>;
}

export function AlertDescription({ children, className = '' }) {
    return <div className={`alert-description ${className}`}>{children}</div>;
}
